<script lang="ts">
	import "../assets/css/ckeditor.css";
	import { transformCkEditorContent } from "../utils/transformCkEditorContent.js";
	import { getSharedGlobalSettings } from "../getSharedGlobalSettings.js";

	export let content: string;

	const { STORAGE_URL } = getSharedGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html transformCkEditorContent(STORAGE_URL, content)}
